import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Pagination from '../../../components/common/Pagination';
import Moment from '../../../components/utils/Moment';
import AdvocateView from './AdvocateView';

export default class AdvocateTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: 0, pageSize: 25 };

    this.state = {
      page: 0,
      pageSize: 25,
      showNotes: false,
      editFlagsMode: false,
    };
  }

  componentWillMount() {
    if (this.props.page > 0) {
      this.setState({ page: this.props.page });
    }
    if (this.props.perPage > 0) {
      this.setState({ pageSize: this.props.perPage });
    }
  }

  fetchData = (state, instance) => {
    return setTimeout(
      () =>
        this.props.fetchData(this.state.page, state.pageSize).then(res => {
          if (this.refs.notesList) {
            this.setState({
              pageSize: state.pageSize,
            });
          }
        }),
      0,
    );
  };

  getTdProps = (state, rowInfo, column, instance) => {
    return {
      onClick: (e, handleOriginal) => {
        if (!rowInfo) {
          return;
        }
        if (
          this.props.selected &&
          rowInfo.original.patientId === this.props.selected.patientId
        ) {
          this.props.selectNote(null);
        } else if (rowInfo) {
          this.props.selectNote(rowInfo.original);
        }
        if (handleOriginal) {
          handleOriginal();
        }
      },
      style: {
        background:
          rowInfo &&
          this.props.selected &&
            rowInfo.original.patientId === this.props.selected.patientId
            ? 'rgba(0,0,0,.13)'
            : '',
      },
    };
  };

  render() {
    const { view, outreaches, advocate } = this.props;
    return (
      <ReactTable
        manual
        ref="advocatesList"
        defaultPageSize={this.state.pageSize}
        //search={search}
        page={this.state.page}
        onPageChange={pageIndex => this.setState({ page: pageIndex })}
        pages={
          this.props.data
            ? Math.ceil(this.props.data.total / this.state.pageSize)
            : 0
        }
        minRows={5}
        loading={this.props.isLoading}
        onFetchData={this.fetchData}
        data={
          this.props.data && this.props.data.list ? this.props.data.list : []
        }
        onSearchChange={this.props.onSearchChange}
        columns={[
          {
            Header: 'Patient ID',
            accessor: 'patientId',
            width: 100
          },
          {
            Header: 'Name',
            id: 'firstName',
            accessor: d =>
              d.firstName + ' ' + d.lastName,
          },
          {
            Header: 'DOB',
            id: 'DOB',
            accessor: 'DOB',
            width: 150,
            Cell: (row) => (
              <Moment
                date={row.original.DOB}
                format="MM/DD/YYYY"
              />
            ),
          },
          {
            Header: 'Age',
            accessor: 'age',
            width: 50
          },
          {
            Header: 'Gender',
            accessor: 'gender',
            width: 100
          },
          {
            Header: 'Athena ID',
            id: 'athenaID',
            accessor: 'athenaID',
            width: 100
          },
          {
            Header: 'Last Outreach',
            accessor: 'lastOutreachDate',
            width: 150
          },
          {
            Header: 'Last Visit',
            accessor: 'lastVisit',
            width: 150
          },
          {
            Header: 'Flags',
            id: 'flags',
            Cell: d => {
              const info = d.original;
              return (
                <span>
                  {info.PreDFlag === 1 && (
                    <span title="PreDiabetes" className="label label-danger">PRED</span>
                  )}
                  {info.DIAFlag === 1 && (
                    <span title="Diabetes" className="label label-warning">DIAB</span>
                  )}
                  {info.HTNFlag === 1 && (
                    <span title="Hypertension" className="label" style={{ backgroundColor: 'blue' }}>HYPT</span>
                  )}
                  {info.HLDFlag === 1 && (
                    <span title="Hyperlipidemia" className="label" style={{ backgroundColor: 'green' }}>HYPL</span>
                  )}
                  {info.AsthmaFlag === 1 && (
                    <span title="Asthma" className="label" style={{ backgroundColor: 'pink' }}>ASTH</span>
                  )}
                  {info.ObesityFlag === 1 && (
                    <span title="Obesity" className="label" style={{ backgroundColor: '#8f6900' }}>OBES</span>
                  )}
                </span>
              );
            },
          },
        ]}
        freezeWhenExpanded={true}
        SubComponent={row => (
          <AdvocateView
            view={view}
            data={advocate}
            showNotes={this.props.showNotes}
            toggleNotes={this.props.toggleNotes}
            editFlagsMode={this.state.editFlagsMode}
            addAction={this.props.addAction}
            outreaches={outreaches}
          />
        )}
        getTdProps={this.getTdProps}
        className="-striped -highlight visit-notes-list-table"
        showPaginationTop={false}
        PaginationComponent={Pagination}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/management/components/AdvocateTable.js